import { Component, OnInit, Input, NgModule } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { FormControl } from '../form-control.model';

@Component({
	selector: 'wncm-form-control-number-plus-less',
	templateUrl: './form-control-number-plus-less.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-number-plus-less.component.scss']
})
export class FormControlNumberPlusLessComponent extends FormControlComponent {
	@Input()
	max: string;

	@Input()
	min: string;

	@Input()
	appearance = 'outline';

	@Input()
	readOnly: boolean;

	@Input()
	activeValue = null;

	constructor() {
		super();

		if (this.readOnly) {
			this.control.disable();
		}
	}

	addOneTo(control: any) {
		const initValue = Number(control.value);
		if (this.max !== undefined) {
			if (control.value < this.max) {
				control.setValue(initValue + 1);
			}
		} else {
			control.setValue(initValue + 1);
		}
		this.activeValue = control.value;
	}

	removeOneTo(control: any) {
		const initValue = Number(control.value);
		if (this.min !== undefined) {
			if (control.value > this.min) {
				control.setValue(initValue - 1);
			}
		} else {
			control.setValue(initValue - 1);
		}
		this.activeValue = control.value;
	}
}
